import React from 'react';

export default function IcEye() {
  return (
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 16" width="100">
<g>
	<path d="M19.9,7.4C18,2.9,14.2,0,10,0S2,2.9,0.1,7.4C0,7.8,0,8.2,0.1,8.6C2,13.1,5.8,16,10,16s8-2.9,9.9-7.4
		C20,8.2,20,7.8,19.9,7.4z M10,14.1c-3.4,0-6.6-2.4-8.2-6.1C3.4,4.2,6.6,1.8,10,1.8s6.6,2.4,8.2,6.2C16.6,11.8,13.4,14.1,10,14.1z"
		/>
	<path d="M10,4.4C8,4.4,6.4,6,6.4,8c0,2,1.6,3.7,3.6,3.7c2,0,3.6-1.6,3.6-3.7C13.6,6,12,4.4,10,4.4z"/>
</g>
</svg>

  );
}
